import { Outlet } from 'react-router-dom';

import { isAuthenticationCompleteSelector } from 'store/auth/selectors';

import { useAnalytic } from 'services/Analytics/useAnalytic';

import { useSelector } from 'hooks';
import useSessionTrackers from '../hooks/useSessionTrackers/useSessionTrackers';
import { useAuthentication } from '../hooks/useAuthentication';

import ModalsRenderer from 'modals';

import { PageLoader } from 'components/PageLoader';

const RootLayout = () => {
    const isComplete = useSelector(isAuthenticationCompleteSelector);

    useAuthentication();
    useAnalytic();
    useSessionTrackers();

    return isComplete ? (
        <>
            <Outlet />
            <ModalsRenderer />
        </>
    ) : (
        <PageLoader />
    );
};

export default RootLayout;
